<ng-template #rulesBody>
  <div class="rule-list-reorder-wrap" [class.dragging]="reorderMode && (draggedRule || draggedGroup)">
    @for (rule of group.rules; track rule) {
      @if (dropHighlight; as h) {
        @if (reorderMode && h.t === 'rule' && h.rule === rule && h.group === group && draggedRule !== rule) {
          <div class="reorder-insertion-bar" aria-hidden="true"></div>
        }
      }
      <div
        [class.draggable]="reorderMode && !draggedRule && !draggedGroup"
        [class.reorder-drag-source]="reorderMode && draggedRule === rule"
        [draggable]="reorderMode"
        (dragstart)="ruleRowDragStart($event, rule)"
        (dragend)="ruleRowDragEnd()"
        (dragenter)="ruleRowDragEnter($event, rule)"
        (dragover)="ruleRowDragOver($event, rule)"
        (drop)="ruleRowDrop($event)"
      >
        <app-custom-rule
          [cosmetic]="cosmetic"
          [reorder]="reorderMode"
          [groupActive]="group.active"
          [rule]="rule"
          [filter]="filter"
          [enableRuleLabels]="enableRuleLabels"
          [isFirstRule]="rule.order === 0"
          [isLastRule]="rule.order === group.rules.length - 1"
          (updateFilter)="updateFilter()"
          (removeRule)="removeRule(rule)"
          (cloneRule)="cloneRule(rule)"
        ></app-custom-rule>
      </div>
    }
    @if (dropHighlight; as h) {
      @if (reorderMode && h.t === 'ruleEnd' && h.group === group) {
        <div class="reorder-insertion-bar reorder-insertion-bar-end" aria-hidden="true"></div>
      }
    }
    @if (reorderMode) {
      <div
        class="rule-reorder-end-drop"
        (dragenter)="ruleListEndDragEnter($event)"
        (dragover)="ruleListEndDragOver($event)"
        (drop)="ruleListEndDrop($event)"
      ></div>
    }
  </div>
  <div class="filter filter-padded" [class.reorder-passthrough]="reorderMode">
    <button type="button" class="btn clear-btn" style="width: 100%;" (click)="addRule()" [disabled]="reorderMode">
      {{ cosmetic ? 'Add Custom Cosmetic Rule' : 'Add Custom Rule' }}
    </button>
  </div>
</ng-template>

@if (dropHighlight; as h) {
  @if (reorderMode && (h.t === 'groupHeader' || h.t === 'ruleHeader') && h.group === group) {
    <div class="reorder-insertion-bar reorder-insertion-bar-group" aria-hidden="true"></div>
  }
}
<div
  class="filter-group"
  [class.reorder-drag-source-group]="reorderMode && draggedGroup === group"
>
  <div
    class="filter-group-header"
    [class.group-header-reorderable]="headerDraggableForGroupReorder()"
    [class.group-header-dragging]="reorderMode && draggedGroup === group"
    [draggable]="headerDraggableForGroupReorder()"
    (dragstart)="groupHeaderDragStart($event)"
    (dragend)="groupHeaderDragEnd()"
    (dragenter)="groupHeaderDragEnter($event)"
    (dragover)="groupHeaderDragOver($event)"
    (drop)="groupHeaderDrop($event)"
  >
    @if (showGroupHeader) {
      <div class="filter">
        <span class="input-group-btn"><button type="button" draggable="false" class="btn toggle-btn" [class.off]="!group.active"
          (click)="toggleGroupActive()"></button></span>
        <span class="filter-body">
          <span class="filter-title">
            @if (!editingName) {
              <span class="filter-title-text group-name-label" (mousedown)="startRename($event)">{{ group.name }}</span>
            } @else {
              <input #groupNameInput type="text" draggable="false" class="form-control group-name-input" [(ngModel)]="group.name" (blur)="finishRename()"
                (keydown.enter)="$any($event.target).blur()" />
            }
          </span>
        </span>
        <span class="input-group-btn"><button type="button" draggable="false" class="btn remove-btn" (click)="onRemoveGroupClick()"></button></span>
      </div>
    } @else if (cosmetic) {
      <div class="filter">
        <span class="filter-body">
          <span filter-title text="Custom Cosmetic Rules" [additionalContent]="defaultCosmeticReorderTpl">
            <app-content cid="custom-cosmetic-rules" contentType="tip"></app-content>
          </span>
          <ng-template #defaultCosmeticReorderTpl>
            @if (showReorderCaption()) {
              <div class="title-toggle-btn">
                Re-order rules and groups
                <span class="input-group-btn">
                  <button type="button" draggable="false" class="btn toggle-btn" [class.off]="!reorderMode" (click)="toggleReorderMode()"></button>
                </span>
              </div>
            }
          </ng-template>
        </span>
      </div>
    } @else {
      <div class="filter filter-padded-left">
        <span class="filter-body">
          <span class="filter-title">
            <span class="filter-title-text">Custom Rules</span>
            @if (showReorderCaption()) {
              <div class="title-toggle-btn">
                Re-order rules and groups
                <span class="input-group-btn">
                  <button type="button" draggable="false" class="btn toggle-btn" [class.off]="!reorderMode" (click)="toggleReorderMode()"></button>
                </span>
              </div>
            }
          </span>
        </span>
      </div>
    }
  </div>

  @if (!headerOnly) {
    <div class="filter-group-body">
      <ng-content select=".custom-rule-group-top-slot"></ng-content>
      <ng-container [ngTemplateOutlet]="rulesBody" />
    </div>
  }

  <div class="clear"></div>
</div>
